import {
    TemplatePmsApiService
} from "./template.service";
import {
    EmailTemplate
} from "../models";

export class EmailTemplatePmsApiService extends TemplatePmsApiService {

 
    newModel(attributes, ...params) {

        return new EmailTemplate(attributes);
    }

    get templateType(){

        return "email-template";
    }

    sendTestEmail(template, recipients) {

        const url = this.url({
            propertyId: template.property.id,
            id: template.id,
            option: 'send-test-email'
        });

        return this.http.post(url, recipients, {
                headers: this.authHeaders,
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());

    }

    restoreDefault(template) {

        const url = this.url({
            propertyId: template.property.id,
            id: template.id,
            option: 'set-default'
        });

        return this.http.put(url, template.toObjectExcept('property'), {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

}


// WEBPACK FOOTER //
// ./src/pms-api/services/email-template.service.js